/**
 * A function to create a log object for the 'callToLoginSignupForm' event (evid: 100)
 *
 * Event description: call to login/signup form.
 *
 * @param {callToLoginSignupFormParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {string} origin - the origin of the request (for example, on home-page there are 3 possible origins, my-account link, start now button and login/signnup link
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<callToLoginSignupFormParams>} LogObject<callToLoginSignupFormParams>
 */
export function callToLoginSignupForm(params) {
    return { evid: 100, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'onSwitchContext' event (evid: 101)
 *
 * Event description: event is generated each time the user moves between screens
 *
 * @param {onSwitchContextParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {string} displayVersion - login version: access link / captcha / other ...
 * @property {string} recoveryMode - for account recovery screen only, which recovery mode the user chose: account recovery/cant access email
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @property {string} referrer - Flow referrer (LFND for example)
 * @return {LogObject<onSwitchContextParams>} LogObject<onSwitchContextParams>
 */
export function onSwitchContext(params) {
    return { evid: 101, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'emptyPassword' event (evid: 102)
 *
 * Event description: empty password.
 *
 * @param {emptyPasswordParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<emptyPasswordParams>} LogObject<emptyPasswordParams>
 */
export function emptyPassword(params) {
    return { evid: 102, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'emptyEmail' event (evid: 104)
 *
 * Event description: empty email.
 *
 * @param {emptyEmailParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<emptyEmailParams>} LogObject<emptyEmailParams>
 */
export function emptyEmail(params) {
    return { evid: 104, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'malformedEmail' event (evid: 105)
 *
 * Event description: malformed email.
 *
 * @param {malformedEmailParams} params - The parameters for this event
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<malformedEmailParams>} LogObject<malformedEmailParams>
 */
export function malformedEmail(params) {
    return { evid: 105, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'malformedPassword' event (evid: 106)
 *
 * Event description: malformed password.
 *
 * @param {malformedPasswordParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<malformedPasswordParams>} LogObject<malformedPasswordParams>
 */
export function malformedPassword(params) {
    return { evid: 106, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginEmailsDonTMatch' event (evid: 107)
 *
 * Event description: login -> emails don't match.
 *
 * @param {loginEmailsDonTMatchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginEmailsDonTMatchParams>} LogObject<loginEmailsDonTMatchParams>
 */
export function loginEmailsDonTMatch(params) {
    return { evid: 107, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginPasswordsDonTMatch' event (evid: 108)
 *
 * Event description: login -> passwords don't match.
 *
 * @param {loginPasswordsDonTMatchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginPasswordsDonTMatchParams>} LogObject<loginPasswordsDonTMatchParams>
 */
export function loginPasswordsDonTMatch(params) {
    return { evid: 108, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginSubmit' event (evid: 110)
 *
 * Event description: event is generated when login form is submitted to server
 *
 * @param {loginSubmitParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {boolean} remember_me - did the user have remember me checked or not. true/false
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} recaptchaChallengeType - none/checkbox/imageselect
 * @property {boolean} formValid - yes for invalid form
 * @property {string} view - desktop,mobile...
 * @return {LogObject<loginSubmitParams>} LogObject<loginSubmitParams>
 */
export function loginSubmit(params) {
    return { evid: 110, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTryLoginRequestSentToServer' event (evid: 111)
 *
 * Event description: login try : login request sent to server.
 *
 * @param {loginTryLoginRequestSentToServerParams} params - The parameters for this event
 * @property {boolean} force - if we use the confusion mechanism-true
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginTryLoginRequestSentToServerParams>} LogObject<loginTryLoginRequestSentToServerParams>
 */
export function loginTryLoginRequestSentToServer(params) {
    return { evid: 111, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTrySuccess' event (evid: 114)
 *
 * Event description: login try : success.
 *
 * @param {loginTrySuccessParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginTrySuccessParams>} LogObject<loginTrySuccessParams>
 */
export function loginTrySuccess(params) {
    return { evid: 114, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'pinterestPixel' event (evid: 115)
 *
 * Event description: Pinterest Pixel was sent
 *
 * @param {pinterestPixelParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<pinterestPixelParams>} LogObject<pinterestPixelParams>
 */
export function pinterestPixel(params) {
    return { evid: 115, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'facebookOrderIdPixelSent' event (evid: 116)
 *
 * Event description: This event is sent when marketing related conversion pixels are sent - upon signup
 *
 * @param {facebookOrderIdPixelSentParams} params - The parameters for this event
 * @property {string} pixel_name - marketing pixel sent
 * @property {string} user_creation_date - user_creation_date from window.__APP_PARAMS__.userCreationDate
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {string} conversion_reporting_event_id - unique id for facebook event
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {number} days_back - days since registration
 * @property {string} view - desktop,mobile
 * @return {LogObject<facebookOrderIdPixelSentParams>} LogObject<facebookOrderIdPixelSentParams>
 */
export function facebookOrderIdPixelSent(params) {
    return { evid: 116, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'socialLoginAuthErrorMarketingLp' event (evid: 117)
 *
 * Event description: event is generated when social authentication failed and the component is within a marketing LP. The error is sent when a user who previously signed up regularly tried to login via social
 *
 * @param {socialLoginAuthErrorMarketingLpParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} reason - a reason of error from social login provider/internal
 * @property {number} errorCode - error code
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialLoginAuthErrorMarketingLpParams>} LogObject<socialLoginAuthErrorMarketingLpParams>
 */
export function socialLoginAuthErrorMarketingLp(params) {
    return { evid: 117, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryAlert' event (evid: 119)
 *
 * Event description: Alert shown to the user when recovery process is not successful
 *
 * @param {accountRecoveryAlertParams} params - The parameters for this event
 * @property {string} name - name of modal
 * @property {string} context - page on which the alert is shown
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop, mobile
 * @return {LogObject<accountRecoveryAlertParams>} LogObject<accountRecoveryAlertParams>
 */
export function accountRecoveryAlert(params) {
    return { evid: 119, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'signupSubmit' event (evid: 120)
 *
 * Event description: event is generated when signup form is submitted to server
 *
 * @param {signupSubmitParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {boolean} formValid - from_valid
 * @property {string} view - origin_view
 * @return {LogObject<signupSubmitParams>} LogObject<signupSubmitParams>
 */
export function signupSubmit(params) {
    return { evid: 120, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'signUpTryRequestSentToServer' event (evid: 121)
 *
 * Event description: sign-up try : request sent to server.
 *
 * @param {signUpTryRequestSentToServerParams} params - The parameters for this event
 * @property {boolean} force - if we use the confusion mechanism-true
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<signUpTryRequestSentToServerParams>} LogObject<signUpTryRequestSentToServerParams>
 */
export function signUpTryRequestSentToServer(params) {
    return { evid: 121, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryRedirect' event (evid: 124)
 *
 * Event description: user is redirected when enters to a middle page in the recovery process (e.g.: using a bookmark)
 *
 * @param {accountRecoveryRedirectParams} params - The parameters for this event
 * @property {string} contextTo - redirect to
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} contextFrom - redirect from
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop, mobile
 * @return {LogObject<accountRecoveryRedirectParams>} LogObject<accountRecoveryRedirectParams>
 */
export function accountRecoveryRedirect(params) {
    return { evid: 124, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryClickNextOnMainPage' event (evid: 125)
 *
 * Event description: event is generated when a user clicks next on "How Can We Help?" page.
 *
 * @param {accountRecoveryClickNextOnMainPageParams} params - The parameters for this event
 * @property {string} name - flow chosen: {reset my password, find my login email, reset my account details, other login questions}
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} displayVersion - old/new
 * @property {GUID} ldSessionID - session id
 * @property {string} view - desktop, mobile
 * @return {LogObject<accountRecoveryClickNextOnMainPageParams>} LogObject<accountRecoveryClickNextOnMainPageParams>
 */
export function accountRecoveryClickNextOnMainPage(params) {
    return { evid: 125, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryErrorOnMandatoryField' event (evid: 126)
 *
 * Event description: event is generated each time the user inserts details with wrong format (e.g. email, website)
 *
 * @param {accountRecoveryErrorOnMandatoryFieldParams} params - The parameters for this event
 * @property {string} name - field name
 * @property {string} description - error text
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<accountRecoveryErrorOnMandatoryFieldParams>} LogObject<accountRecoveryErrorOnMandatoryFieldParams>
 */
export function accountRecoveryErrorOnMandatoryField(params) {
    return { evid: 126, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'emailDoesnTExistMessageDisplayed' event (evid: 127)
 *
 * Event description: user tried to login or reset password with email that doesn't exist
 *
 * @param {emailDoesnTExistMessageDisplayedParams} params - The parameters for this event
 * @property {string} context - login/forgot-password
 * @property {string} __cookies_prefix___ga - deprecated
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - deprecated
 * @return {LogObject<emailDoesnTExistMessageDisplayedParams>} LogObject<emailDoesnTExistMessageDisplayedParams>
 */
export function emailDoesnTExistMessageDisplayed(params) {
    return { evid: 127, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'findLoginEmailSmsIsSent' event (evid: 128)
 *
 * Event description: event is generated each time a sms is sent (server)
 *
 * @param {findLoginEmailSmsIsSentParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - origin_view
 * @return {LogObject<findLoginEmailSmsIsSentParams>} LogObject<findLoginEmailSmsIsSentParams>
 */
export function findLoginEmailSmsIsSent(params) {
    return { evid: 128, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'proceedingToPasswordClickContinue' event (evid: 129)
 *
 * Event description: login redesign - click to move from "enter your email" to "enter your password"
 *
 * @param {proceedingToPasswordClickContinueParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {string} source_type - signup / login
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<proceedingToPasswordClickContinueParams>} LogObject<proceedingToPasswordClickContinueParams>
 */
export function proceedingToPasswordClickContinue(params) {
    return { evid: 129, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'forgotPasswordSubmit' event (evid: 131)
 *
 * Event description: event is generated when forgot password form is submitted to server
 *
 * @param {forgotPasswordSubmitParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {boolean} formValid - yes for invalid form
 * @property {string} view - desktop,mobile..
 * @return {LogObject<forgotPasswordSubmitParams>} LogObject<forgotPasswordSubmitParams>
 */
export function forgotPasswordSubmit(params) {
    return { evid: 131, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryRequestSubmit' event (evid: 134)
 *
 * Event description: event is generated when a user submits one of the requests in account recovery flow.
 * name of request: {contact-us, reset-free (reset account for free site) ,reset-premium...}
 *
 * @param {accountRecoveryRequestSubmitParams} params - The parameters for this event
 * @property {string} name - what was submitted: {contact-us,reset-free,reset-premium...}
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryRequestSubmitParams>} LogObject<accountRecoveryRequestSubmitParams>
 */
export function accountRecoveryRequestSubmit(params) {
    return { evid: 134, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'proceedingToPasswordError' event (evid: 135)
 *
 * Event description: could not move from mail to password (login redesign)
 *
 * @param {proceedingToPasswordErrorParams} params - The parameters for this event
 * @property {string} errorMessage - error message
 * @property {string} __cookies_prefix___ga - ga
 * @property {string} source_type - signup / login
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<proceedingToPasswordErrorParams>} LogObject<proceedingToPasswordErrorParams>
 */
export function proceedingToPasswordError(params) {
    return { evid: 135, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'clickOnForgotButton' event (evid: 136)
 *
 * Event description: click on "forgot" button in the login funnel
 *
 * @param {clickOnForgotButtonParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - differentiate by button source: email / login / old version / etc...
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<clickOnForgotButtonParams>} LogObject<clickOnForgotButtonParams>
 */
export function clickOnForgotButton(params) {
    return { evid: 136, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'viewPreIntroScreen' event (evid: 137)
 *
 * Event description: User visits the screen between signup and start intro. The purpose of this screen is to help acquisition to segment users who cannot track due to new cookies policies.
 *
 * @param {viewPreIntroScreenParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<viewPreIntroScreenParams>} LogObject<viewPreIntroScreenParams>
 */
export function viewPreIntroScreen(params) {
    return { evid: 137, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'socialDebug' event (evid: 138)
 *
 * Event description: social debug
 *
 * @param {socialDebugParams} params - The parameters for this event
 * @property {string} step - debug step name
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialDebugParams>} LogObject<socialDebugParams>
 */
export function socialDebug(params) {
    return { evid: 138, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'socialLoginEarlyClick' event (evid: 139)
 *
 * Event description: event is generated when social login button is clicked before social sdk finished downloading
 *
 * @param {socialLoginEarlyClickParams} params - The parameters for this event
 * @property {string} socialNetwork - social_network
 * @property {string} context - context
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialLoginEarlyClickParams>} LogObject<socialLoginEarlyClickParams>
 */
export function socialLoginEarlyClick(params) {
    return { evid: 139, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'socialLoginClicked' event (evid: 140)
 *
 * Event description: event is generated when social login button is clicked
 *
 * @param {socialLoginClickedParams} params - The parameters for this event
 * @property {string} socialNetwork - 'google', 'facebook'
 * @property {string} context - context
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} type - 'social'
 * @property {string} view - origin_view
 * @return {LogObject<socialLoginClickedParams>} LogObject<socialLoginClickedParams>
 */
export function socialLoginClicked(params) {
    return { evid: 140, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'socialAuthError' event (evid: 141)
 *
 * Event description: event is generated when social authentication failed
 *
 * @param {socialAuthErrorParams} params - The parameters for this event
 * @property {string} state - state
 * @property {string} socialNetwork - social_network
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialAuthErrorParams>} LogObject<socialAuthErrorParams>
 */
export function socialAuthError(params) {
    return { evid: 141, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'socialAuthSuccess' event (evid: 142)
 *
 * Event description: event is generated when social authentication succeeded
 *
 * @param {socialAuthSuccessParams} params - The parameters for this event
 * @property {string} state - only for google via redirect from gdomain / googleOT / googleButton
 * @property {string} socialNetwork - google, facebook
 * @property {string} context - login, signup, gdomain
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {boolean} interactive - is_consent_page
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialAuthSuccessParams>} LogObject<socialAuthSuccessParams>
 */
export function socialAuthSuccess(params) {
    return { evid: 142, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'verifyAccountSubmit' event (evid: 143)
 *
 * Event description: event is generated when verify account form is submitted to server
 *
 * @param {verifyAccountSubmitParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {boolean} formValid - yes for invalid form
 * @property {string} view - desktop,mobile..
 * @return {LogObject<verifyAccountSubmitParams>} LogObject<verifyAccountSubmitParams>
 */
export function verifyAccountSubmit(params) {
    return { evid: 143, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'getEmailSubmit' event (evid: 149)
 *
 * Event description: event is generated when get email form is submitted to server
 *
 * @param {getEmailSubmitParams} params - The parameters for this event
 * @property {string} socialNetwork - social_network
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {boolean} formValid - form_valid
 * @property {string} view - origin_view
 * @return {LogObject<getEmailSubmitParams>} LogObject<getEmailSubmitParams>
 */
export function getEmailSubmit(params) {
    return { evid: 149, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationVerifyClick' event (evid: 150)
 *
 * Event description: a user that enabled 2-factor authentication clicks on 'verify' after entering the code sent to his mobile, during the login/step-up process.
 *
 * @param {loginTwoFactorAuthenticationVerifyClickParams} params - The parameters for this event
 * @property {string} tfa_type - "login" / "step-up"
 * @property {boolean} remember_this_device - true/false - did the user check the box 'remember this device for 30 days'
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/phone
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationVerifyClickParams>} LogObject<loginTwoFactorAuthenticationVerifyClickParams>
 */
export function loginTwoFactorAuthenticationVerifyClick(params) {
    return { evid: 150, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationResendCodeClick' event (evid: 151)
 *
 * Event description: a user that enabled 2-factor authentication clicks on 'resend code' in the 'check your phone' dialog box, during the login/step-up process.
 *
 * @param {loginTwoFactorAuthenticationResendCodeClickParams} params - The parameters for this event
 * @property {string} tfa_type - "login" / "step-up"
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/sms
 * @property {string} view - origin_view
 * @property {string} reason - Reason this page was loaded (Login\ LFND model)
 * @return {LogObject<loginTwoFactorAuthenticationResendCodeClickParams>} LogObject<loginTwoFactorAuthenticationResendCodeClickParams>
 */
export function loginTwoFactorAuthenticationResendCodeClick(params) {
    return { evid: 151, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationLostPhoneAccessClick' event (evid: 152)
 *
 * Event description: a user that enabled 2-factor authentication clicks on 'lost access to your phone' in the 'check your phone' dialog box, during the login process.
 *
 * @param {loginTwoFactorAuthenticationLostPhoneAccessClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - phone/email/totp
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationLostPhoneAccessClickParams>} LogObject<loginTwoFactorAuthenticationLostPhoneAccessClickParams>
 */
export function loginTwoFactorAuthenticationLostPhoneAccessClick(params) {
    return { evid: 152, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationVerifySuccess' event (evid: 153)
 *
 * Event description: a user successfully verified a correct code during 2-factor authentication login/step-up
 *
 * @param {loginTwoFactorAuthenticationVerifySuccessParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/phone
 * @property {string} view - origin_view
 * @property {string} reason - Reason this page was loaded (Login\ LFND model)
 * @return {LogObject<loginTwoFactorAuthenticationVerifySuccessParams>} LogObject<loginTwoFactorAuthenticationVerifySuccessParams>
 */
export function loginTwoFactorAuthenticationVerifySuccess(params) {
    return { evid: 153, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationVerifyFail' event (evid: 154)
 *
 * Event description: the verification failed due to incorrect code entered by the user, during 2-factor authentication login
 *
 * @param {loginTwoFactorAuthenticationVerifyFailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/sms
 * @property {string} view - origin_view
 * @property {string} reason - Reason this page was loaded (Login\ LFND model)
 * @return {LogObject<loginTwoFactorAuthenticationVerifyFailParams>} LogObject<loginTwoFactorAuthenticationVerifyFailParams>
 */
export function loginTwoFactorAuthenticationVerifyFail(params) {
    return { evid: 154, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginClickOnBack' event (evid: 155)
 *
 * Event description: The user clicks on 'back' during the login process
 *
 * @param {loginClickOnBackParams} params - The parameters for this event
 * @property {string} step_name - in which step the user clicked 'back' (enter password/verify code)
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - phone/email/totp
 * @property {string} view - origin_view
 * @return {LogObject<loginClickOnBackParams>} LogObject<loginClickOnBackParams>
 */
export function loginClickOnBack(params) {
    return { evid: 155, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationPageLoad' event (evid: 156)
 *
 * Event description: Page load of 2fa screen (where the user is asked to enter the verification code)
 *
 * @param {loginTwoFactorAuthenticationPageLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - where the user was directed to 2FA from: regular login- 'login', or 'deviant art'
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/sms
 * @property {string} view - origin_view
 * @property {string} reason - Reason this page was loaded (Login\ LFND model)
 * @return {LogObject<loginTwoFactorAuthenticationPageLoadParams>} LogObject<loginTwoFactorAuthenticationPageLoadParams>
 */
export function loginTwoFactorAuthenticationPageLoad(params) {
    return { evid: 156, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneEnterEmailModalLoad' event (evid: 157)
 *
 * Event description: The modal of "enter your email address you lost access to"  loaded after the user chose "can't access my login email" from the account recovery options
 *
 * @param {accountRecoveryByPhoneEnterEmailModalLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneEnterEmailModalLoadParams>} LogObject<accountRecoveryByPhoneEnterEmailModalLoadParams>
 */
export function accountRecoveryByPhoneEnterEmailModalLoad(params) {
    return { evid: 157, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneClickNextAfterEnteringEmail' event (evid: 158)
 *
 * Event description: The user clicked on next after entering email address in the phone recovery flow
 *
 * @param {accountRecoveryByPhoneClickNextAfterEnteringEmailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneClickNextAfterEnteringEmailParams>} LogObject<accountRecoveryByPhoneClickNextAfterEnteringEmailParams>
 */
export function accountRecoveryByPhoneClickNextAfterEnteringEmail(params) {
    return { evid: 158, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneResetPasswordOptionsModalLoad' event (evid: 159)
 *
 * Event description: The modal with optional ways to reset password was loaded
 *
 * @param {accountRecoveryByPhoneResetPasswordOptionsModalLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneResetPasswordOptionsModalLoadParams>} LogObject<accountRecoveryByPhoneResetPasswordOptionsModalLoadParams>
 */
export function accountRecoveryByPhoneResetPasswordOptionsModalLoad(params) {
    return { evid: 159, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneResetPasswordOptionChosen' event (evid: 160)
 *
 * Event description: The event is sent when the user clicks on "next" after choosing an option to reset password: link to recovery email (if exists), code to the recovery phone number (if exists), or neither
 *
 * @param {accountRecoveryByPhoneResetPasswordOptionChosenParams} params - The parameters for this event
 * @property {string} chosen_option - recovery email/recovery phone/no access
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneResetPasswordOptionChosenParams>} LogObject<accountRecoveryByPhoneResetPasswordOptionChosenParams>
 */
export function accountRecoveryByPhoneResetPasswordOptionChosen(params) {
    return { evid: 160, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneVerifyCodePageLoad' event (evid: 161)
 *
 * Event description: Load of 'check your phone' modal during account recovery by phone flow
 *
 * @param {accountRecoveryByPhoneVerifyCodePageLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneVerifyCodePageLoadParams>} LogObject<accountRecoveryByPhoneVerifyCodePageLoadParams>
 */
export function accountRecoveryByPhoneVerifyCodePageLoad(params) {
    return { evid: 161, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneVerifyCodeClick' event (evid: 162)
 *
 * Event description: The user clicked on 'verify' after entering the code sent to his phone, during  account recovery
 *
 * @param {accountRecoveryByPhoneVerifyCodeClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneVerifyCodeClickParams>} LogObject<accountRecoveryByPhoneVerifyCodeClickParams>
 */
export function accountRecoveryByPhoneVerifyCodeClick(params) {
    return { evid: 162, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneResendCodeClick' event (evid: 163)
 *
 * Event description: The user clicked on 'resend code' during  account recovery by phone
 *
 * @param {accountRecoveryByPhoneResendCodeClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneResendCodeClickParams>} LogObject<accountRecoveryByPhoneResendCodeClickParams>
 */
export function accountRecoveryByPhoneResendCodeClick(params) {
    return { evid: 163, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneLostPhoneAccessClick' event (evid: 164)
 *
 * Event description: The user clicked on 'lost access to your phone?' during  account recovery by phone
 *
 * @param {accountRecoveryByPhoneLostPhoneAccessClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneLostPhoneAccessClickParams>} LogObject<accountRecoveryByPhoneLostPhoneAccessClickParams>
 */
export function accountRecoveryByPhoneLostPhoneAccessClick(params) {
    return { evid: 164, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneCodeVerifiedSuccessfully' event (evid: 165)
 *
 * Event description: The user clicked on 'lost access to your phone?' during  account recovery by phone
 *
 * @param {accountRecoveryByPhoneCodeVerifiedSuccessfullyParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneCodeVerifiedSuccessfullyParams>} LogObject<accountRecoveryByPhoneCodeVerifiedSuccessfullyParams>
 */
export function accountRecoveryByPhoneCodeVerifiedSuccessfully(params) {
    return { evid: 165, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneCodeVerificationFailed' event (evid: 166)
 *
 * Event description: The user clicked on 'lost access to your phone?' during  account recovery by phone
 *
 * @param {accountRecoveryByPhoneCodeVerificationFailedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneCodeVerificationFailedParams>} LogObject<accountRecoveryByPhoneCodeVerificationFailedParams>
 */
export function accountRecoveryByPhoneCodeVerificationFailed(params) {
    return { evid: 166, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneSelectNewPasswordModalLoad' event (evid: 167)
 *
 * Event description: Load of 'select new password' modal
 *
 * @param {accountRecoveryByPhoneSelectNewPasswordModalLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneSelectNewPasswordModalLoadParams>} LogObject<accountRecoveryByPhoneSelectNewPasswordModalLoadParams>
 */
export function accountRecoveryByPhoneSelectNewPasswordModalLoad(params) {
    return { evid: 167, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneSaveNewPasswordClick' event (evid: 168)
 *
 * Event description: The user clicked on "save new password" during account recovery by phone
 *
 * @param {accountRecoveryByPhoneSaveNewPasswordClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneSaveNewPasswordClickParams>} LogObject<accountRecoveryByPhoneSaveNewPasswordClickParams>
 */
export function accountRecoveryByPhoneSaveNewPasswordClick(params) {
    return { evid: 168, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneSuccessScreenSelection' event (evid: 169)
 *
 * Event description: The user selected one of two options in the success screen after saving a new password -  go to account settings/go to dashboard, or closed the modal
 *
 * @param {accountRecoveryByPhoneSuccessScreenSelectionParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} selection - account settings/dashboard/close
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneSuccessScreenSelectionParams>} LogObject<accountRecoveryByPhoneSuccessScreenSelectionParams>
 */
export function accountRecoveryByPhoneSuccessScreenSelection(params) {
    return { evid: 169, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'answerPreIntroScreen' event (evid: 170)
 *
 * Event description: Users answers the pre intro screen
 *
 * @param {answerPreIntroScreenParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} answer - answer
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<answerPreIntroScreenParams>} LogObject<answerPreIntroScreenParams>
 */
export function answerPreIntroScreen(params) {
    return { evid: 170, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'signUpPasswordStrengthIndicator' event (evid: 171)
 *
 * Event description: this event contains the indicators of each password saved during a sign up
 *
 * @param {signUpPasswordStrengthIndicatorParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {string} __cookies_prefix___ga - ga
 * @property {string} strength - Numeric score
 * @property {GUID} client_id - client_id
 * @property {string} origin - where the password was choswn: sign up/reset password/account settings
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<signUpPasswordStrengthIndicatorParams>} LogObject<signUpPasswordStrengthIndicatorParams>
 */
export function signUpPasswordStrengthIndicator(params) {
    return { evid: 171, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationSmsErrorDisplayed' event (evid: 172)
 *
 * Event description: Sent when we show users an error message saying we're having trouble sending the 2FA verification code via sms, and suggest them to get it via email
 *
 * @param {loginTwoFactorAuthenticationSmsErrorDisplayedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationSmsErrorDisplayedParams>} LogObject<loginTwoFactorAuthenticationSmsErrorDisplayedParams>
 */
export function loginTwoFactorAuthenticationSmsErrorDisplayed(params) {
    return { evid: 172, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationClickToGet2FaCodeViaEmail' event (evid: 173)
 *
 * Event description: Sent when the user clicks on "click here to get it via email" in the error message we show, that says we're having trouble sending the code via sms
 *
 * @param {loginTwoFactorAuthenticationClickToGet2FaCodeViaEmailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationClickToGet2FaCodeViaEmailParams>} LogObject<loginTwoFactorAuthenticationClickToGet2FaCodeViaEmailParams>
 */
export function loginTwoFactorAuthenticationClickToGet2FaCodeViaEmail(params) {
    return { evid: 173, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'emailLoginInteractionData' event (evid: 174)
 *
 * Event description: This event is for collecting data regarding email-login interaction being above 100%
 *
 * @param {emailLoginInteractionDataParams} params - The parameters for this event
 * @property {string} timestamp_date - the time the interaction event sent in date format
 * @property {number} timestamp_ms - the time the interaction event sent in ms
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} error_info - the error, in case occurred
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} type - start/end-success/end-error
 * @property {string} email_hash - the use's email hashed
 * @property {number} error_code - the error status code, in case occurred
 * @property {string} view - origin_view
 * @return {LogObject<emailLoginInteractionDataParams>} LogObject<emailLoginInteractionDataParams>
 */
export function emailLoginInteractionData(params) {
    return { evid: 174, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175' event (evid: 175)
 *
 * Event description: The user clicked on 'send code by phone' in the 2fa login screen
 *
 * @param {loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175Params} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - app/email (what flow type the user was in when he clicked on send code by phone)
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175Params>} LogObject<loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175Params>
 */
export function loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175(params) {
    return { evid: 175, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationSendCodeByPhoneClick' event (evid: 176)
 *
 * Event description: The user clicked on 'send code by email' in the 2fa login screen
 *
 * @param {loginTwoFactorAuthenticationSendCodeByPhoneClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - app/phone (which flow the user was in when he clicked on send code by email)
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationSendCodeByPhoneClickParams>} LogObject<loginTwoFactorAuthenticationSendCodeByPhoneClickParams>
 */
export function loginTwoFactorAuthenticationSendCodeByPhoneClick(params) {
    return { evid: 176, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginSocialLoginErrorInIncognito' event (evid: 177)
 *
 * Event description: The user tried to login with Google in chrome incognito mode, and received an error message. Google doesn’t allow 3rd party cookie in Incognito mode in recent Chrome versions (from ~June 2020).
 *
 * @param {loginSocialLoginErrorInIncognitoParams} params - The parameters for this event
 * @property {string} socialNetwork - social_network
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginSocialLoginErrorInIncognitoParams>} LogObject<loginSocialLoginErrorInIncognitoParams>
 */
export function loginSocialLoginErrorInIncognito(params) {
    return { evid: 177, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationInternalBug' event (evid: 178)
 *
 * Event description: Login - Two Factor Authentication - Internal Bug
 *
 * @param {loginTwoFactorAuthenticationInternalBugParams} params - The parameters for this event
 * @property {string} timestamp_date - timestamp_date
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ldSessionID
 * @property {string} type - type
 * @property {string} email_hash - email_hash
 * @property {string} view - origin_view
 * @property {number} counter_value - counter_value
 * @return {LogObject<loginTwoFactorAuthenticationInternalBugParams>} LogObject<loginTwoFactorAuthenticationInternalBugParams>
 */
export function loginTwoFactorAuthenticationInternalBug(params) {
    return { evid: 178, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationLoginWithAuthenticatorAppClick' event (evid: 179)
 *
 * Event description: The user clicked on 'login with authenticator app' in the 2fa login screen, while in the email/phone flow
 *
 * @param {loginTwoFactorAuthenticationLoginWithAuthenticatorAppClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - origin
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationLoginWithAuthenticatorAppClickParams>} LogObject<loginTwoFactorAuthenticationLoginWithAuthenticatorAppClickParams>
 */
export function loginTwoFactorAuthenticationLoginWithAuthenticatorAppClick(params) {
    return { evid: 179, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginPageClickOnLogInWithSso' event (evid: 180)
 *
 * Event description: Login Page - Click on Log in with SSO.
 *
 * @param {loginPageClickOnLogInWithSsoParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginPageClickOnLogInWithSsoParams>} LogObject<loginPageClickOnLogInWithSsoParams>
 */
export function loginPageClickOnLogInWithSso(params) {
    return { evid: 180, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'wixSsoLoginPageClickOnContinueAfterEnteringEmail' event (evid: 181)
 *
 * Event description: In the Log in with SSO page, after clicking "Log in with SSO" in the regular Wix login page, the user enters their Email address and clicks on "Continue".
 *
 * @param {wixSsoLoginPageClickOnContinueAfterEnteringEmailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<wixSsoLoginPageClickOnContinueAfterEnteringEmailParams>} LogObject<wixSsoLoginPageClickOnContinueAfterEnteringEmailParams>
 */
export function wixSsoLoginPageClickOnContinueAfterEnteringEmail(params) {
    return { evid: 181, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'wixSsoLoginPageClickOnBack' event (evid: 182)
 *
 * Event description: In the Log in with SSO page, after clicking "Log in with SSO" in the regular Wix login page, the user clicks on 'Back'
 *
 * @param {wixSsoLoginPageClickOnBackParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<wixSsoLoginPageClickOnBackParams>} LogObject<wixSsoLoginPageClickOnBackParams>
 */
export function wixSsoLoginPageClickOnBack(params) {
    return { evid: 182, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'ssoLoginRequestClickToConnectWithSsoYellowButton' event (evid: 183)
 *
 * Event description: SSO Login Request - Click to Connect with SSO (Yellow Button).
 *
 * @param {ssoLoginRequestClickToConnectWithSsoYellowButtonParams} params - The parameters for this event
 * @property {GUID} state - similar to session id for SSO
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {GUID} account_id - account id of the channel account that enabled SSO
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<ssoLoginRequestClickToConnectWithSsoYellowButtonParams>} LogObject<ssoLoginRequestClickToConnectWithSsoYellowButtonParams>
 */
export function ssoLoginRequestClickToConnectWithSsoYellowButton(params) {
    return { evid: 183, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'googleOneTapModalLoad' event (evid: 186)
 *
 * Event description: Google One Tap Modal Load (in one of Wix's landing pages, while the user is logged in to his Google account in the same browser)
 *
 * @param {googleOneTapModalLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<googleOneTapModalLoadParams>} LogObject<googleOneTapModalLoadParams>
 */
export function googleOneTapModalLoad(params) {
    return { evid: 186, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginAccountSelectorComponentLoad' event (evid: 188)
 *
 * Event description: A user with multiple accounts tried to log in and saw the account selector component, allowing him to select one of his accounts.
 *
 * @param {loginAccountSelectorComponentLoadParams} params - The parameters for this event
 * @property {string} account_ids - an array with all the account ids available for selection. Coupled with parent accounts in the same order.
 * @property {string} context - login/reset password
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} parent_account_ids - an array with all the parent account ids of the accounts in the selection. If no parent account exists - the value will be null
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginAccountSelectorComponentLoadParams>} LogObject<loginAccountSelectorComponentLoadParams>
 */
export function loginAccountSelectorComponentLoad(params) {
    return { evid: 188, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginAccountSelectorAccountSelected' event (evid: 189)
 *
 * Event description: The user selected one of the accounts available in account selector
 *
 * @param {loginAccountSelectorAccountSelectedParams} params - The parameters for this event
 * @property {GUID} parent_account_id - parent account of the selected account id
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} selected_account_id - the selected account id
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginAccountSelectorAccountSelectedParams>} LogObject<loginAccountSelectorAccountSelectedParams>
 */
export function loginAccountSelectorAccountSelected(params) {
    return { evid: 189, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginPageOnStart' event (evid: 300)
 *
 * Event description: event is generated when login dialog starts
 *
 * @param {loginPageOnStartParams} params - The parameters for this event
 * @property {string} context - context
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - available window width
 * @property {string} origin - the origin of the request (for example, on home-page there are 3 possible origins, my-account link, start now button and login/signnup link
 * @property {string} context_button - Which button the user clicked before getting this page
 * @property {string} ver - ver
 * @property {string} context_type - Context type, usually will happen when the user has UIDX cookie (for example - 'Multi account'/sso')
 * @property {number} screen_height - Height of client device screen
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {number} avail_height - available window height
 * @property {string} referrer_context - which experience the users was supposed to get? (signup\login)
 * @property {string} view - desktop,mobile..
 * @property {string} referrer - Context referrer (LFND\account recovery)
 * @return {LogObject<loginPageOnStartParams>} LogObject<loginPageOnStartParams>
 */
export function loginPageOnStart(params) {
    return { evid: 300, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginDialogInitComplete' event (evid: 302)
 *
 * Event description: login dialog -> INIT_COMPLETE.
 *
 * @param {loginDialogInitCompleteParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginDialogInitCompleteParams>} LogObject<loginDialogInitCompleteParams>
 */
export function loginDialogInitComplete(params) {
    return { evid: 302, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'onClose' event (evid: 303)
 *
 * Event description: event is generated when user clicks big X button
 *
 * @param {onCloseParams} params - The parameters for this event
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<onCloseParams>} LogObject<onCloseParams>
 */
export function onClose(params) {
    return { evid: 303, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'errorEventNotClosingInteraction' event (evid: 305)
 *
 * Event description: A detailed error event, sent when the interaction is not closed
 *
 * @param {errorEventNotClosingInteractionParams} params - The parameters for this event
 * @property {string} ga - ga
 * @property {string} context - context
 * @property {string} interaction_name - interaction_name
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} error - error received (text)
 * @property {string} origin - the origin of the request (for example, on home-page there are 3 possible origins, my-account link, start now button and login/signnup link
 * @property {string} request_id - request_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} error_code - error_code (number)
 * @property {string} view - origin_view
 * @return {LogObject<errorEventNotClosingInteractionParams>} LogObject<errorEventNotClosingInteractionParams>
 */
export function errorEventNotClosingInteraction(params) {
    return { evid: 305, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginDialogFullStoryReady' event (evid: 400)
 *
 * Event description: event is generated (if and) when fullstory recording start
 *
 * @param {loginDialogFullStoryReadyParams} params - The parameters for this event
 * @property {string} fullStoryUrl - full story url
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginDialogFullStoryReadyParams>} LogObject<loginDialogFullStoryReadyParams>
 */
export function loginDialogFullStoryReady(params) {
    return { evid: 400, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationCallMeCodeClick' event (evid: 401)
 *
 * Event description: a user that enabled 2-factor authentication clicks on 'call me' during the login / step-up process.
 *
 * @param {loginTwoFactorAuthenticationCallMeCodeClickParams} params - The parameters for this event
 * @property {string} tfa_type - "login" / "step-up"
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - session ID
 * @property {string} view - desktop / mobile
 * @return {LogObject<loginTwoFactorAuthenticationCallMeCodeClickParams>} LogObject<loginTwoFactorAuthenticationCallMeCodeClickParams>
 */
export function loginTwoFactorAuthenticationCallMeCodeClick(params) {
    return { evid: 401, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'userClickedOnContinueWithEmail' event (evid: 402)
 *
 * Event description: When the user clicks on the "continue with email" button on the combined signup and login form
 *
 * @param {userClickedOnContinueWithEmailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<userClickedOnContinueWithEmailParams>} LogObject<userClickedOnContinueWithEmailParams>
 */
export function userClickedOnContinueWithEmail(params) {
    return { evid: 402, src: 6, endpoint: 'hls2', params: params };
}
/**
 * A function to create a log object for the 'loginSignupPageClickOnSwitchForm' event (evid: 403)
 *
 * Event description: event is generated when the user clicks on switch to signup form (on the login form) and when he clicks on switch to login (on the signup form).
 *
 * @param {loginSignupPageClickOnSwitchFormParams} params - The parameters for this event
 * @property {string} context - context of the page (signup\login)
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop/mobile
 * @property {string} switch_to - What button the user clicked (switch to - login\signup)?
 * @return {LogObject<loginSignupPageClickOnSwitchFormParams>} LogObject<loginSignupPageClickOnSwitchFormParams>
 */
export function loginSignupPageClickOnSwitchForm(params) {
    return { evid: 403, src: 6, endpoint: 'hls2', params: params };
}
//# sourceMappingURL=index.js.map